import { useContext, useEffect, useState } from 'react'
import '../css/user/edituser.css'
import { Dimcontext } from '../../context/pagecontext'
import { Button, Form, FormControl, FormGroup, FormLabel, Row, Col } from 'react-bootstrap'
import { MdClose, MdVisibility, MdContactPhone, MdAssignmentInd, MdVerifiedUser, MdPhotoCamera } from 'react-icons/md'
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { Datacontext } from '../../context/dataContext'

export const Viewuser = ({ set_view, id }) => {
    const { setDim } = useContext(Dimcontext)
    const { users } = useContext(Datacontext) 
    const [userd, setuserd] = useState({
        uid: '',
        name: '',
        mobile: '',
        amobile: '',
        aadharno: '',
        role: '',
        relname: '',
        relmobile: '',
        docdet: '',
        email: '',
        profileImage: '' // Added profileImage
    })

    const handleviewclose = () => {
        set_view(false)
        setDim(false)
    }

    useEffect(() => {
    // 1. Find the user object
    const selectedUser = users.find(item => item.id === id);

    // 2. Only update if the user was actually found
    if (selectedUser) {
        setuserd({
            uid: selectedUser.uid || '',
            name: selectedUser.name || '',
            mobile: selectedUser.mobile || '',
            amobile: selectedUser.amobile || '',
            role: selectedUser.role || 'user',
            // Redacting sensitive ID for display logic
            aadharno: selectedUser.aadharno || '', 
            relname: selectedUser.relname || '',
            relmobile: selectedUser.relmobile || '',
            docdet: selectedUser.docdet || 'no',
            email: selectedUser.email || '',
            profileImage: selectedUser.profileImage || ''
        });
    }
}, [id, users]); // The effect re-runs if the ID changes or the User list is updated

    return (
        <div className="edituser-card shadow-lg">
            <div className="modal-header-custom">
                <div className="header-title">
                    <MdVisibility className="me-2" />
                    <span>View User Details</span>
                </div>
                <button onClick={handleviewclose} className="btn-close-custom">
                    <MdClose />
                </button>
            </div>

            <SimpleBar style={{ width: '100%', height: 'calc(85vh - 70px)' }} noScrollX>
                <Form className="p-4">

                    {/* Section: Profile Image Display */}
                    <div className="form-section text-center mb-4">
                        <h6 className="section-title text-start"><MdPhotoCamera className="me-2"/>Profile Photo</h6>
                        <div className="d-flex justify-content-center p-3 border rounded bg-light">
                            {userd.profileImage ? (
                                <img 
                                    src={userd.profileImage} 
                                    alt="Profile" 
                                    className="rounded-circle shadow border border-3 border-white" 
                                    style={{ width: '120px', height: '120px', objectFit: 'cover' }} 
                                />
                            ) : (
                                <div 
                                    className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white shadow" 
                                    style={{ width: '120px', height: '120px' }}
                                >
                                    <span style={{ fontSize: '0.8rem' }}>No Image</span>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    {/* Section: Identity Details */}
                    <div className="form-section">
                        <h6 className="section-title">
                            <MdAssignmentInd className="me-2"/>Identity & System
                        </h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>User ID</FormLabel>
                                    <FormControl readOnly value={userd.uid} className="input-readonly text-muted" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Account Role</FormLabel>
                                    <FormControl readOnly value={userd.role.toUpperCase()} className="input-readonly fw-bold text-primary" />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <FormLabel>Full Name</FormLabel>
                                    <FormControl readOnly value={userd.name.toUpperCase()} className="input-readonly" />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    {/* Section: Contact Details */}
                    <div className="form-section">
                        <h6 className="section-title">
                            <MdContactPhone className="me-2"/>Contact Information
                        </h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Primary Mobile</FormLabel>
                                    <FormControl readOnly value={userd.mobile} className="input-readonly" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Email Address</FormLabel>
                                    <FormControl readOnly value={userd.email} className="input-readonly" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Relative Name</FormLabel>
                                    <FormControl readOnly value={userd.relname.toUpperCase()} className="input-readonly" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Relative Mobile</FormLabel>
                                    <FormControl readOnly value={userd.relmobile} className="input-readonly" />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    {/* Section: Verification */}
                    <div className="form-section">
                        <h6 className="section-title">
                            <MdVerifiedUser className="me-2"/>Verification Status
                        </h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Aadhar Number</FormLabel>
                                    <FormControl readOnly value={userd.aadharno} className="input-readonly" />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <div className="doc-collect-box border p-3 rounded bg-white">
                                    <FormLabel className="me-4 fw-bold mb-0">Original Document Collected?</FormLabel>
                                    <Form.Check 
                                        inline 
                                        disabled 
                                        label="Yes" 
                                        type="radio" 
                                        checked={userd.docdet === 'yes'} 
                                    />
                                    <Form.Check 
                                        inline 
                                        disabled 
                                        label="No" 
                                        type="radio" 
                                        checked={userd.docdet === 'no'} 
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="footer-actions sticky-bottom bg-white p-3 border-top">
                        <Button variant="outline-secondary" className="px-5 w-100 shadow-sm" onClick={handleviewclose}>
                            Close Details
                        </Button>
                    </div>
                </Form>
            </SimpleBar>
        </div>
    )
}